import { graphql, readInlineData } from "react-relay";

import { article as articleData } from "~/data";
import type { helpersCheckIsOpinionArticle$key } from "~/queries/__generated__/helpersCheckIsOpinionArticle.graphql";

export const checkIsOpinionArticle = (reference: helpersCheckIsOpinionArticle$key) => {
  const article = readInlineData(
    graphql`
      fragment helpersCheckIsOpinionArticle on Article @inline {
        types {
          value {
            entityId
          }
        }
      }
    `,
    reference,
  );

  const [articleType] = article.types?.flatMap(type => type?.value) ?? [];

  const type = articleType?.entityId ?? "";

  return articleData.types.opinion.entityId === type || articleData.types.column.entityId === type;
};
